import React from 'react';

interface Props {
  onOpenModal: () => void;
}

const BuildStatusCell: React.FC<Props> = ({ onOpenModal }) => (
  <button
    onClick={onOpenModal}
    title="Generate build"
    className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-[11px] font-bold tracking-wide transition-colors"
  >
    BUILD
  </button>
);

export default BuildStatusCell;
